import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useEffect } from 'react'
import { useHistory } from 'react-router'
import { IStore } from '../interfaces/Store'
import { getInitialData } from '../services/Kyc'
import {
  initialDataFailed,
  initialDataLoading,
  initialDataReceived,
} from '../store/actions'
import { STATUS } from '../enums/common'
import { handleError } from '../services/utils'

/**
 * Initial hook that need to be called on every step
 * It will internally check if there is a need to fetch the data from BE
 *
 * @return object with is loading property;
 */
const useInitHook = (): { status: string } => {
  const history = useHistory()
  const status: string = useSelector(
    (state: IStore) => state.folderReducer.status
  )
  const dispatch = useDispatch()

  const init = useCallback(async (): Promise<void> => {
    dispatch(initialDataLoading())
    try {
      const response = await getInitialData({ history })
      // @ts-ignore
      dispatch(initialDataReceived(response))
    } catch (e) {
      dispatch(initialDataFailed(e.message))
      handleError(e, history)
    }
  }, [dispatch, history])

  useEffect(() => {
    if (status === STATUS.idle) {
      init()
    }
  }, [status, init])

  return { status }
}

export default useInitHook
